import {
	DELETE_INSURANCE_COMPANY,
	DELETE_INSURANCE_COMPANY_SUCCESS,
	DELETE_INSURANCE_COMPANY_FAIL,
	DELETE_INSURANCE_COMPANY_RESET,
} from '../actions/deleteInsuranceCompanyAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const deleteInsuranceCompanyReducer = (state = initialState, action) => {
	switch (action.type) {
		case DELETE_INSURANCE_COMPANY:
			return {
				...state,
				apiState: 'loading',
			};
		case DELETE_INSURANCE_COMPANY_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case DELETE_INSURANCE_COMPANY_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case DELETE_INSURANCE_COMPANY_RESET:
			return initialState;
		default:
			return state;
	}
};

export default deleteInsuranceCompanyReducer;
